<template>
    <modal v-if="name" :name="name" class="dd-m-modal dd-m-modal--simple-success">
        <button v-on:click="hide()" type="button" class="dd-m-modal--simple-success__close-btn">
            <i class="dd-m-icon icon-close"></i>
        </button>

        <div class="dd-m-modal--simple-success__content">
            <h2 v-if="title" class="dd-m-modal--simple-success__title">{{title}}</h2>

            <button type="button"
                    v-on:click="hide()"
                    class="dd-m-button dd-m-button--default dd-m-button--assertive">
                {{buttonText ? buttonText : 'Back'}}
            </button>
        </div>
    </modal>
</template>
<script>
    export default {
        name: 'modal-simple-success',
        props: ['title', 'modalRef', 'name', 'buttonText'],
        mounted() {
            PubSub.subscribe(`close${this.modalRef}Modal`, () => this.hide());
            PubSub.subscribe(`open${this.modalRef}Modal`, () => this.show());
        },
        methods: {
            show() {
                this.$modal.show(this.name);
            },
            hide() {
                this.$modal.hide(this.name);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/site/js/components/custom-modals/modal-simple-success.vue